import { HourglassTop, CheckCircle, Policy } from '@mui/icons-material';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const DonorConfig: any = {
    private: 'Private',
    public: 'Public',
    donor: 'CSR Partner',
    volunteer: 'Volunteer',
    'csr': 'CSR Cell',
    'csr-cell': 'CSR Cell',
    'csr_cell': 'CSR Cell',
    'CSR Cell': 'CSR Cell',
    "central-psu": 'Central PSU',
    "state-psu": 'State PSU',
    partenership: 'Partenership',
    proprietorship: 'Proprietorship',
    "society-trust": 'Society / Trust',
    individual :"Individual",
    Individual :"Individual",
    "non-company": "Non-Company",
    others: 'Others',
    'autonomous-body': 'Statutory Body',
    'satutory-body': 'Statutory Body',
    section: 'Section-8',
    company_psu: 'Company / PSU',
    'donor-foundation': 'CSR Partner Foundation',
    autonomous_body: 'Statutory Body',
    statutory_body: 'Statutory Body',
    government_user :'Society Member',
    partnership :'Partnership',
    implementing_agency :'NGO',
}

export const userStatusConfig: Record< string, { label: { English: string; Hindi: string };  color: "warning" | "success" | "error"; icon: React.ReactNode; allowDelete: boolean } > = {
    pending: {
        label: { English: "Pending", Hindi: "लंबित" },
        color: "warning",
        icon: <HourglassTop />,
        allowDelete: true, 
    },
    approved: {
        label: { English: "Approved", Hindi: "अनुमोदित" },
        color: "success",
        icon: <CheckCircle />,
        allowDelete: false,
    },
    rejected: {
        label: { English: "Rejected", Hindi: "अस्वीकृत" },
        color: "error",
        icon: <HighlightOffIcon fontSize="small" />, 
        allowDelete: false,
    },
    compliance: {
        label: { English: "Compliance Pending", Hindi: "अनुपालन लंबित" },
        color: "error",
        icon: <Policy />,
        allowDelete: false,
      },
};
